export type BlogPost = {
  slug: string;
  title: string;
  description: string;
  date: string;
  keywords: string;
  html: string;
};

// Import markdown posts
import { html as wsolHtml } from "./what-is-wrapped-sol.md";
import { html as solanaBotHtml } from "./how-to-build-solana-trading-bot.md";
import { html as raydiumHtml } from "./raydium-trading-data-api-tutorial.md";
import { html as pumpfunHtml } from "./pumpfun-trades-graduations-api-tutorial.md";
import { html as meteoraHtml } from "./meteora-dex-trading-data-api-tutorial.md";
import { html as hyperliquidHtml } from "./hyperliquid-perpetuals-orderbook-api-tutorial.md";
import { html as polymarketHtml } from "./polymarket-orderbook-api-tutorial.md";

export const BLOG_POSTS: BlogPost[] = [
  {
    slug: "raydium-trading-data-api-tutorial",
    title: "How to Stream Raydium Trades and Pool Data in Real-Time",
    description:
      "Stream real-time Raydium trades, detect new pools, query historic data, and get pool info across AMM, CPMM, CLMM, and LaunchLab using the Sailfish SDK.",
    date: "2026-03-27",
    keywords:
      "Raydium API, Raydium SDK, getallpools Raydium, Raydium trading data, Raydium pool data, Sailfish SDK, Solana DEX API",
    html: raydiumHtml,
  },
  {
    slug: "pumpfun-trades-graduations-api-tutorial",
    title: "How to Track PumpFun and PumpSwap Trades and Graduations",
    description:
      "Stream PumpFun bonding curve trades, detect token graduations, track PumpSwap AMM activity, and query historic graduation data using the Sailfish SDK.",
    date: "2026-03-27",
    keywords:
      "PumpFun API, PumpSwap API, PumpFun graduation, PumpFun trading data, PumpFun bonding curve, token graduation, Sailfish SDK",
    html: pumpfunHtml,
  },
  {
    slug: "meteora-dex-trading-data-api-tutorial",
    title: "How to Stream Meteora DEX Trades and Pool Data in Real-Time",
    description:
      "Stream real-time Meteora trades across DAMM, DAMM2, and DLMM pools. Detect new pools, query historic data, and compare prices across DEXs using the Sailfish SDK.",
    date: "2026-03-27",
    keywords:
      "Meteora API, Meteora DEX, Meteora DLMM, Meteora DAMM, Meteora trading data, Sailfish SDK, Solana DEX API",
    html: meteoraHtml,
  },
  {
    slug: "hyperliquid-perpetuals-orderbook-api-tutorial",
    title: "How to Stream Hyperliquid Perpetuals Data in Real-Time",
    description:
      "Stream real-time Hyperliquid perpetuals trades via WebSocket. Filter by market, query historic data, and build price feeds using the Sailfish SDK.",
    date: "2026-03-27",
    keywords:
      "Hyperliquid API, Hyperliquid orderbook, Hyperliquid WebSocket, Hyperliquid perps data, Hyperliquid trading data, Sailfish SDK",
    html: hyperliquidHtml,
  },
  {
    slug: "polymarket-orderbook-api-tutorial",
    title: "How to Stream Polymarket Orderbooks in Real-Time",
    description:
      "Stream real-time Polymarket orderbooks via WebSocket. Monitor prediction markets, calculate implied probabilities, and build market monitors using the Sailfish SDK.",
    date: "2026-03-27",
    keywords:
      "Polymarket API, Polymarket orderbook, Polymarket WebSocket, Polymarket data, prediction market API, Sailfish SDK",
    html: polymarketHtml,
  },
  {
    slug: "how-to-build-solana-trading-bot",
    title: "How to Build a Solana Trading Bot in 2026",
    description:
      "A practical guide to building your first Solana trading bot using the Sailfish SDK. From real-time data streaming to executing trades on Raydium and PumpFun.",
    date: "2026-03-23",
    keywords:
      "Solana trading bot, how to build trading bot, Sailfish SDK, algorithmic trading, Solana bot tutorial",
    html: solanaBotHtml,
  },
  {
    slug: "what-is-wrapped-sol",
    title: "What is Wrapped SOL (wSOL) and Why Do You Need It?",
    description:
      "A complete guide to Wrapped SOL (wSOL) on Solana. What it is, why DeFi protocols require it, how to wrap and unwrap SOL, and common use cases.",
    date: "2026-03-23",
    keywords:
      "wrapped SOL, wSOL, what is wSOL, wrap SOL, Solana DeFi, SPL token",
    html: wsolHtml,
  },
];
